<template>
  <div style="width: 100%; height: 100%; position: relative; min-height: 500px">
    <div
      v-if="!map"
      style="
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #999;
        position: absolute;
        z-index: 1;
      "
    >
      地图加载中...
    </div>
    <div
      ref="mapContainer"
      style="width: 100%; height: 100%; position: relative; z-index: 0"
    ></div>

    <div style="height: 40px" class="flex autocompelete">
      <el-autocomplete
        popper-class="my-autocomplete"
        placeholder="搜企业"
        v-model="keyword"
        :fetch-suggestions="querySearch"
        @select="handleSelect"
      >
        <i
          class="el-icon-error el-input__icon"
          slot="suffix"
          style="font-size: 24px"
          @click="handleIconClick"
          v-if="keyword"
        >
        </i>
        <template slot-scope="{ item }">
          <div class="flex">
            <img
              src="../../assets/images/home/search.png"
              class="search_img mt_9"
            />
            <div class="name">{{ item.name }}</div>
            <div class="addr">{{ item.city }}{{ item.area }}</div>
          </div>
        </template>
      </el-autocomplete>
    </div>

    <div
      class="flex autocompelete autocompelete-right"
      @click="handleIconClick"
    >
      <div
        class="text-center cursor-pointer"
        :class="item.clicked ? 'checkedStyle' : 'unchecked'"
        v-for="(item, index) in typeList"
        :key="index"
        @click.stop="chooseType(item)"
      >
        {{ item.label }}
      </div>

      <div class="searchInfo" v-if="info.name" @click.stop="handleNative()">
        <div class="fz_20 plr_20 font_blod">{{ info.name }}</div>
        <el-divider></el-divider>
        <div class="flex plr_20">
          <img src="../../assets/images/home/local.png" class="local_img" />
          <div class="fz_14 ml_10">
            {{ info.province }}{{ info.city }}{{ info.area }}{{ info.address }}
          </div>
        </div>
        <el-divider></el-divider>
        <div class="flex plr_20">
          <div class="left_icon"></div>
          <div class="fz_14 ml_10">服务情况</div>
        </div>
        <div class="plr_20 bg_num mt_15">
          <img src="../../assets/images/home/num.png" class="num_img" />
          <div>
            <div class="fc_333333 fz_16 font_blod">{{ info.count }}人</div>
            <div class="fz_12 fc_666666 mt_15">服务人数</div>
          </div>
        </div>
        <el-divider></el-divider>
        <div class="flex plr_20">
          <div class="left_icon"></div>
          <div class="fz_14 ml_10">公司实景</div>
        </div>
        <div class="plr_20 mt_15 flex imageList">
          <img
            :src="item"
            class="info_img"
            v-for="(item, index) in info.imgs"
            :key="index"
            @click="handleToDetail(item)"
          />
        </div>
      </div>
    </div>

    <el-dialog
      :visible.sync="imgViewDlgVisible"
      :modal-append-to-body="false"
      width="550px"
    >
      <img width="100%" :src="ImgUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import {
  polygonPath1,
  polygonPath2,
  polygonPath3,
  polygonPath4,
} from "./polygon2";
import { getHot, getHotOne } from "@/api/home";

export default {
  name: "HotMap",
  data() {
    return {
      map: null,
      center: {
        lng: 120.330219,
        lat: 31.68196,
      },
      mapList: [],
      polygonPath1: [],
      polygonPath2: [],
      polygonPath3: [],
      polygonPath4: [],
      showLable: true,
      labelStyle: {
        color: "#717885",
        fontSize: "24px",
        border: "none",
        backgroundColor: "transparent",
        opacity: "0.7",
      },
      polygonPath11: [],
      polygonPath22: [],
      polygonPath33: [],
      polygonPath44: [],
      keyword: "",
      typeList: [
        {
          value: "1",
          label: "热力图",
          clicked: true,
        },
        {
          value: "2",
          label: "点位图",
          clicked: false,
        },
      ],
      showMap: true,
      hotmarkImg: require("@/assets/images/home/hotmark.png"),
      info: {},
      markerList: [],
      imgViewDlgVisible: false,
      ImgUrl: "",
      zoom: 12,
      id: "",
      showSearch: false,
      // 腾讯地图相关对象
      multiMarker: null,
      multiPolygon: null,
      heatmap: null, // 腾讯地图官方热力图对象
      labelMarker: null,
      TMapAPI: null, // 腾讯地图GL API对象
      QQMapAPI: null, // 腾讯地图JS API v2对象（用于热力图）
      // 性能优化相关
      isZooming: false, // 是否正在缩放
      updateTimer: null, // 更新定时器
    };
  },

  mounted() {
    this.polygonPath1 = polygonPath1;
    this.polygonPath2 = polygonPath2;
    this.polygonPath3 = polygonPath3;
    this.polygonPath4 = polygonPath4;
    this.polygonPath1.forEach((item) => {
      this.polygonPath11.push({
        lng: item.lng + 0.00414, //+ 0.011,
        lat: item.lat - 0.002, // + 0.0035,
      });
    });
    this.polygonPath2.forEach((item) => {
      this.polygonPath22.push({
        lng: item.lng + 0.00414, //+ 0.011,
        lat: item.lat - 0.002, // + 0.0035,
      });
    });
    this.polygonPath3.forEach((item) => {
      this.polygonPath33.push({
        lng: item.lng + 0.00414, //+ 0.011,
        lat: item.lat - 0.002, // + 0.0035,
      });
    });
    this.polygonPath4.forEach((item) => {
      this.polygonPath44.push({
        lng: item.lng + 0.00414, //+ 0.011,
        lat: item.lat - 0.002, // + 0.0035,
      });
    });

    // 延迟初始化，确保DOM和API都准备好
    this.$nextTick(() => {
      setTimeout(() => {
        this.initMap();
        this.getHotInfo();
      }, 200);
    });
  },

  beforeDestroy() {
    // 清理定时器
    if (this.updateTimer) {
      clearTimeout(this.updateTimer);
      this.updateTimer = null;
    }

    if (this.map) {
      this.map.destroy();
    }
  },

  watch: {
    mapList: {
      handler() {
        // 延迟更新，避免频繁触发
        this.throttleUpdate(() => {
          this.updateMapData();
        }, 200);
      },
      deep: true,
    },
    markerList: {
      handler() {
        // 只有在显示点位图时才更新标记点
        if (!this.showMap) {
          // 延迟更新标记点，避免频繁触发
          this.throttleUpdate(() => {
            this.updateMarkers();
          }, 200);
        } else {
          // 如果显示热力图，确保标记点隐藏
          if (this.multiMarker) {
            this.multiMarker.setMap(null);
          }
        }
      },
      deep: true,
    },
    showMap: {
      handler() {
        this.updateMapData();
      },
    },
    center: {
      handler() {
        if (this.map && this.TMapAPI) {
          this.map.setCenter(
            new this.TMapAPI.LatLng(this.center.lat, this.center.lng),
          );
        }
      },
      deep: true,
    },
    zoom: {
      handler() {
        if (this.map) {
          this.map.setZoom(this.zoom);
        }
      },
    },
  },

  methods: {
    initMap(retryCount = 0) {
      const maxRetries = 50; // 最多重试50次（5秒）

      // 等待DOM和腾讯地图API加载完成
      this.$nextTick(() => {
        if (!this.$refs.mapContainer) {
          if (retryCount < maxRetries) {
            setTimeout(() => this.initMap(retryCount + 1), 100);
          } else {
            console.error("地图容器未找到");
          }
          return;
        }

        // 检查腾讯地图API是否加载
        if (typeof TMap === "undefined" && typeof window.TMap === "undefined") {
          if (retryCount < maxRetries) {
            if (retryCount % 10 === 0) {
              console.warn(
                `腾讯地图API未加载，等待中... (${retryCount}/${maxRetries})`,
              );
              console.log("检查window对象:", typeof window.TMap, typeof TMap);
            }
            setTimeout(() => this.initMap(retryCount + 1), 100);
          } else {
            console.error("腾讯地图API加载超时，请检查网络连接和API key");
            console.error(
              "请确认 public/index.html 中已正确引入腾讯地图API脚本",
            );
          }
          return;
        }

        // 使用全局TMap或window.TMap
        const TMapAPI =
          typeof TMap !== "undefined"
            ? TMap
            : typeof window !== "undefined"
            ? window.TMap
            : null;
        if (!TMapAPI) {
          console.error("腾讯地图API对象未找到");
          return;
        }

        // 将TMapAPI保存到实例中，供其他方法使用
        this.TMapAPI = TMapAPI;
        console.log("TMapAPI已初始化:", !!this.TMapAPI);

        try {
          // 确保容器有尺寸
          const container = this.$refs.mapContainer;
          if (
            !container ||
            container.offsetWidth === 0 ||
            container.offsetHeight === 0
          ) {
            if (retryCount < maxRetries) {
              console.warn("地图容器尺寸为0，等待重试...");
              setTimeout(() => this.initMap(retryCount + 1), 200);
            } else {
              console.error("地图容器尺寸始终为0，请检查CSS样式");
            }
            return;
          }

          const center = new TMapAPI.LatLng(this.center.lat, this.center.lng);

          // 腾讯地图GL API的配置选项
          const mapOptions = {
            center: center,
            zoom: this.zoom,
            enableScrollWheelZoom: false, // 禁用默认滚轮缩放，使用自定义实现
            minZoom: 3, // 最小缩放级别
            maxZoom: 20, // 最大缩放级别
            // 禁用默认控件
            disableDefaultUI: true, // 如果API支持，禁用所有默认UI控件
            zoomControl: false, // 如果API支持，禁用缩放控件
          };

          // 腾讯地图GL API可能不需要mapTypeId，或者使用不同的方式
          // 如果MapTypeId存在，则尝试添加地图类型
          try {
            if (TMapAPI.MapTypeId) {
              if (TMapAPI.MapTypeId.NORMAL) {
                mapOptions.mapTypeId = TMapAPI.MapTypeId.NORMAL;
              } else if (TMapAPI.MapTypeId.ROADMAP) {
                mapOptions.mapTypeId = TMapAPI.MapTypeId.ROADMAP;
              }
            }
          } catch (e) {
            // MapTypeId不存在，忽略此参数
            console.log("MapTypeId不可用，使用默认地图类型");
          }

          this.map = new TMapAPI.Map(container, mapOptions);

          console.log("地图初始化成功", "TMapAPI:", !!this.TMapAPI);

          // 移除默认的缩放控件（+/-按钮）
          try {
            // 腾讯地图GL API可能使用不同的方法移除控件
            // 尝试多种方式移除缩放控件
            if (this.map.removeControl) {
              this.map.removeControl("zoom");
            }
            if (this.map.hideControl) {
              this.map.hideControl("zoom");
            }
            // 通过CSS和DOM操作隐藏缩放控件
            setTimeout(() => {
              // 查找并隐藏所有可能的缩放控件
              const selectors = [
                ".tmap-zoom",
                ".tmap-control-zoom",
                ".tmap-ctrl-zoom",
                '[class*="zoom-control"]',
                '[class*="ZoomControl"]',
                ".tmap-ctrl-container",
                ".tmap-ctrl-top-right",
                ".tmap-ctrl-top-left",
              ];

              selectors.forEach((selector) => {
                const controls = container.querySelectorAll(selector);
                controls.forEach((control) => {
                  if (control && control.style) {
                    control.style.display = "none";
                    control.style.visibility = "hidden";
                  }
                });
              });

              // 也尝试在整个文档中查找（针对每个选择器）
              selectors.forEach((selector) => {
                const allControls = document.querySelectorAll(selector);
                allControls.forEach((control) => {
                  // 检查控件是否在地图容器内
                  if (
                    control &&
                    container.contains &&
                    container.contains(control)
                  ) {
                    if (control.style) {
                      control.style.display = "none";
                      control.style.visibility = "hidden";
                    }
                  }
                });
              });
            }, 200);
          } catch (e) {
            console.log("移除缩放控件失败，将使用CSS隐藏:", e);
          }

          // 触发地图resize，确保正确显示
          setTimeout(() => {
            if (this.map) {
              this.map.resize();
            }
          }, 100);

          // 监听缩放开始事件
          this.map.on("zoomstart", () => {
            this.isZooming = true;
          });

          // 监听缩放结束事件（优化：减少延迟，提高响应速度）
          this.map.on("zoom_changed", () => {
            this.zoom = this.map.getZoom();
            if (this.map.getZoom() < 12) {
              this.showLable = false;
            } else {
              this.showLable = true;
              this.labelStyle.fontSize = this.map.getZoom() * 2 + "px";
            }

            // 立即标记缩放结束，减少延迟
            this.isZooming = false;

            // 使用较短的延迟更新标签，提高响应性
            this.throttleUpdate(() => {
              this.updateLabels();
            }, 100);
          });

          // 监听点击事件
          this.map.on("click", () => {
            this.handleIconClick();
          });

          // 设置自定义鼠标滚轮缩放，增加缩放步长
          this.setupWheelZoom();

          // 初始化多边形
          this.initPolygons();

          // 初始化标签
          this.initLabels();

          // 确保默认显示热力图，不显示点位图
          this.showMap = true;
          this.typeList[0].clicked = true;
          this.typeList[1].clicked = false;

          // 确保标记点不显示（如果已存在），默认不显示点位图
          if (this.multiMarker) {
            this.multiMarker.setMap(null);
          }

          // 确保数据加载后更新地图（默认只显示热力图，不显示点位图）
          if (this.mapList && this.mapList.length > 0) {
            // 只显示热力图，不显示点位图
            this.updateHeatmap();
            // 确保标记点隐藏
            if (this.multiMarker) {
              this.multiMarker.setMap(null);
            }
          }
        } catch (error) {
          console.error("地图初始化失败:", error);
        }
      });
    },

    // 获取腾讯地图API对象
    getTMap() {
      if (this.TMapAPI) return this.TMapAPI;
      if (typeof TMap !== "undefined") {
        this.TMapAPI = TMap;
        return TMap;
      }
      if (typeof window !== "undefined" && window.TMap) {
        this.TMapAPI = window.TMap;
        return window.TMap;
      }
      return null;
    },

    // 确保TMapAPI已初始化
    ensureTMapAPI() {
      if (!this.TMapAPI) {
        const api = this.getTMap();
        if (api) {
          this.TMapAPI = api;
          return true;
        }
        return false;
      }
      return true;
    },

    // 坐标转换：BD-09（百度坐标系）转GCJ-02（腾讯/高德坐标系）
    // 如果数据来自百度地图，需要转换；如果来自高德地图，则不需要转换
    convertCoordinate(lat, lng) {
      // 高德地图和腾讯地图都使用GCJ-02坐标系，理论上偏差很小
      // 如果数据来自百度地图（BD-09），则需要转换
      // 这里提供BD-09转GCJ-02的转换算法

      const x_PI = (3.14159265358979324 * 3000.0) / 180.0;

      // BD-09转GCJ-02
      let x = lng - 0.0065;
      let y = lat - 0.006;
      let z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_PI);
      let theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_PI);
      let gcj_lng = z * Math.cos(theta);
      let gcj_lat = z * Math.sin(theta);

      return {
        lat: gcj_lat,
        lng: gcj_lng,
      };
    },

    // 坐标转换（简化版，如果不需要复杂转换，可以使用简单的偏移）
    // 高德地图和腾讯地图都使用GCJ-02，理论上偏差很小
    // 如果需要微调，可以使用这个函数
    adjustCoordinate(lat, lng, offsetLat = 0, offsetLng = 0) {
      return {
        lat: lat + offsetLat,
        lng: lng + offsetLng,
      };
    },

    // 节流函数：限制函数执行频率
    throttleUpdate(func, delay) {
      if (this.updateTimer) {
        clearTimeout(this.updateTimer);
      }
      this.updateTimer = setTimeout(() => {
        func();
        this.updateTimer = null;
      }, delay);
    },

    // 防抖函数：延迟执行，只在停止触发后执行
    debounceUpdate(func, delay) {
      if (this.updateTimer) {
        clearTimeout(this.updateTimer);
      }
      this.updateTimer = setTimeout(() => {
        func();
        this.updateTimer = null;
      }, delay);
    },

    // 设置自定义鼠标滚轮缩放，增加缩放步长
    setupWheelZoom() {
      if (!this.map || !this.$refs.mapContainer) return;

      const container = this.$refs.mapContainer;
      let wheelTimer = null;

      // 监听鼠标滚轮事件
      container.addEventListener(
        "wheel",
        (e) => {
          e.preventDefault();
          e.stopPropagation();

          // 清除之前的定时器
          if (wheelTimer) {
            clearTimeout(wheelTimer);
          }

          // 计算缩放增量（增加步长）
          const delta = e.deltaY > 0 ? -1 : 1; // 向下滚动缩小，向上滚动放大
          const zoomStep = 1.5; // 增加缩放步长，原来是1，现在改为1.5

          // 获取当前缩放级别
          const currentZoom = this.map.getZoom();
          const newZoom = Math.max(
            3,
            Math.min(20, currentZoom + delta * zoomStep),
          );

          // 使用节流，避免频繁缩放
          wheelTimer = setTimeout(() => {
            if (this.map) {
              this.map.setZoom(newZoom);
            }
          }, 50);
        },
        { passive: false },
      );
    },

    initPolygons() {
      if (!this.map || !this.TMapAPI) return;

      const polygons = [
        {
          id: "polygon1",
          paths: this.polygonPath11.map(
            (p) => new this.TMapAPI.LatLng(p.lat, p.lng),
          ),
        },
        {
          id: "polygon2",
          paths: this.polygonPath22.map(
            (p) => new this.TMapAPI.LatLng(p.lat, p.lng),
          ),
        },
        {
          id: "polygon3",
          paths: this.polygonPath33.map(
            (p) => new this.TMapAPI.LatLng(p.lat, p.lng),
          ),
        },
        {
          id: "polygon4",
          paths: this.polygonPath44.map(
            (p) => new this.TMapAPI.LatLng(p.lat, p.lng),
          ),
        },
      ];

      this.multiPolygon = new this.TMapAPI.MultiPolygon({
        map: this.map,
        styles: {
          default: new this.TMapAPI.PolygonStyle({
            color: "#DBDDE5",
            borderColor: "#7D92E6",
            borderWidth: 5,
            opacity: 0.02, // 大幅降低透明度，使遮罩几乎透明，能看到底下的地图
          }),
        },
        geometries: polygons.map((p) => ({
          id: p.id,
          styleId: "default",
          paths: p.paths,
        })),
      });
    },

    initLabels() {
      if (!this.map || !this.TMapAPI) return;

      const labelPositions = [
        {
          id: "label1",
          lat: 31.68065298,
          lng: 120.32666102,
          text: "惠山经济开发区",
        },
        {
          id: "label2",
          lat: 31.712548,
          lng: 120.215349,
          text: "惠山工业转型集聚区",
        },
        { id: "label3", lat: 31.648503, lng: 120.285515, text: "堰桥街道" },
        { id: "label4", lat: 31.718219, lng: 120.165382, text: "玉祁街道" },
      ];

      this.labelMarker = new this.TMapAPI.MultiMarker({
        map: this.map,
        styles: {
          default: new this.TMapAPI.MarkerStyle({
            width: 0,
            height: 0,
          }),
        },
        geometries: labelPositions.map((p) => ({
          id: p.id,
          styleId: "default",
          // position: new this.TMapAPI.LatLng(p.lat, p.lng),
          properties: {
            title: p.text,
          },
        })),
      });

      // 创建文本标签
      this.updateLabels();
    },

    updateLabels() {
      if (!this.map || !this.showLable) return;

      // 移除旧的标签
      const oldLabels = document.querySelectorAll(".tmap-label");
      oldLabels.forEach((label) => label.remove());

      if (this.map.getZoom() < 12) return;

      const labelPositions = [
        { lat: 31.68065298, lng: 120.32666102, text: "惠山经济开发区" },
        { lat: 31.712548, lng: 120.215349, text: "惠山工业转型集聚区" },
        { lat: 31.648503, lng: 120.285515, text: "堰桥街道" },
        { lat: 31.718219, lng: 120.165382, text: "玉祁街道" },
      ];

      if (!this.TMapAPI) return;

      labelPositions.forEach((pos) => {
        // 腾讯地图GL API使用projectToContainer而不是project
        const pixel = this.map.projectToContainer(
          new this.TMapAPI.LatLng(pos.lat, pos.lng),
        );
        const label = document.createElement("div");
        label.className = "tmap-label";
        label.textContent = pos.text;
        label.style.cssText = `
          position: absolute;
          left: ${pixel.x}px;
          top: ${pixel.y}px;
          color: ${this.labelStyle.color};
          font-size: ${this.labelStyle.fontSize};
          background: transparent;
          border: none;
          opacity: ${this.labelStyle.opacity};
          pointer-events: none;
          transform: translate(-50%, -100%);
          white-space: nowrap;
        `;
        this.$refs.mapContainer.appendChild(label);
      });

      // 监听地图移动更新标签位置
      // 优化：减少延迟，提高响应性
      this.map.on("move", () => {
        this.throttleUpdate(() => {
          this.updateLabels();
        }, 30);
      });
    },

    updateMapData() {
      if (!this.map) return;
      // 缩放时不阻止更新，让地图更流畅

      if (this.showMap) {
        // 显示热力图
        this.updateHeatmap();
        // 隐藏标记点（不销毁，只是隐藏），确保不显示点位图
        if (this.multiMarker) {
          this.multiMarker.setMap(null);
        }
        // 确保热力图显示在最上层
        if (this.heatmap && this.heatmap.parentNode) {
          this.heatmap.style.zIndex = "100";
        }
      } else {
        // 显示点位图：隐藏热力图，显示标记点
        // 先隐藏热力图
        if (this.heatmap) {
          try {
            if (this.heatmap.hide) {
              this.heatmap.hide();
            } else if (this.heatmap.destroy) {
              this.heatmap.destroy();
              this.heatmap = null;
            }
          } catch (e) {
            console.warn("隐藏热力图失败:", e);
          }
        }
        // 显示标记点（如果已存在且数据未变，直接显示；否则重新创建）
        if (this.multiMarker && this.markerList.length > 0) {
          // 如果标记点已存在，直接显示
          this.multiMarker.setMap(this.map);
        } else if (this.markerList.length > 0) {
          // 否则重新创建
          this.updateMarkers();
        }
      }
    },

    updateHeatmap() {
      if (!this.map || !this.mapList || this.mapList.length === 0) {
        console.log("热力图更新条件不满足:", {
          hasMap: !!this.map,
          mapListLength: this.mapList?.length || 0,
        });
        return;
      }

      // 确保TMapAPI已初始化
      if (!this.ensureTMapAPI()) {
        console.warn("TMapAPI未初始化，无法绘制热力图，等待重试...");
        setTimeout(() => {
          if (this.ensureTMapAPI()) {
            this.updateHeatmap();
          }
        }, 200);
        return;
      }

      // 移除旧的热力图
      if (this.heatmap) {
        if (this.heatmap.parentNode) {
          this.heatmap.parentNode.removeChild(this.heatmap);
        }
        this.heatmap = null;
      }

      // 腾讯地图GL版本使用Canvas实现热力图
      // 创建canvas元素用于绘制热力图
      const container = this.$refs.mapContainer;
      if (!container) {
        console.warn("地图容器未找到");
        return;
      }

      const canvas = document.createElement("canvas");
      canvas.width = container.offsetWidth || 800;
      canvas.height = container.offsetHeight || 600;
      canvas.style.position = "absolute";
      canvas.style.top = "0";
      canvas.style.left = "0";
      canvas.style.pointerEvents = "none";
      canvas.style.zIndex = "100";

      const ctx = canvas.getContext("2d");
      // 参照示例代码，设置辐射半径为30（示例代码中的默认值）
      const radius = 30;
      // 计算数据的最大值和最小值（参照示例代码的数据格式）
      let maxValue = 0;
      let minValue = Infinity;
      this.mapList.forEach((item) => {
        const value = item.count || 1;
        if (value > maxValue) maxValue = value;
        if (value < minValue) minValue = value;
      });
      const max = maxValue || 100;
      const min = minValue || 0;

      console.log("开始绘制热力图，数据点数量:", this.mapList.length);

      // 绘制热力图点
      this.mapList.forEach((item) => {
        if (!item.lat || !item.lng) {
          console.warn("数据点缺少经纬度:", item);
          return;
        }

        try {
          // 坐标转换：如果数据来自百度地图，需要转换为腾讯地图坐标系
          const coord = this.convertCoordinate(item.lat, item.lng);
          const latLng = new this.TMapAPI.LatLng(coord.lat, coord.lng);
          // 腾讯地图GL API使用projectToContainer而不是project
          const pixel = this.map.projectToContainer(latLng);
          // 参照示例代码，计算强度值（归一化到0-1之间）
          const value = item.count || 1;
          const intensity = (value - min) / (max - min || 1);

          // 创建径向渐变，调整渐变范围让热力图更聚集
          const gradient = ctx.createRadialGradient(
            pixel.x,
            pixel.y,
            0,
            pixel.x,
            pixel.y,
            radius,
          );
          // 调整颜色渐变，让中心更集中，边缘更柔和
          gradient.addColorStop(0, `rgba(255, 0, 0, ${intensity * 1.0})`);
          gradient.addColorStop(0.3, `rgba(255, 100, 0, ${intensity * 0.8})`);
          gradient.addColorStop(0.6, `rgba(255, 200, 0, ${intensity * 0.5})`);
          gradient.addColorStop(1, "rgba(255, 255, 0, 0)");

          ctx.fillStyle = gradient;
          ctx.beginPath();
          ctx.arc(pixel.x, pixel.y, radius, 0, Math.PI * 2);
          ctx.fill();
        } catch (e) {
          console.error("绘制热力图点失败:", e, item);
        }
      });

      container.appendChild(canvas);
      this.heatmap = canvas;
      console.log("热力图绘制完成");

      // 监听地图移动和缩放，更新热力图（使用节流优化）
      const updateHeatmap = () => {
        if (!this.heatmap || !this.map || this.isZooming) return;
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        if (!this.TMapAPI) return;

        // 使用固定的半径30（参照示例代码）
        const currentRadius = radius;

        this.mapList.forEach((item) => {
          // 坐标转换
          const coord = this.convertCoordinate(item.lat, item.lng);
          // 腾讯地图GL API使用projectToContainer而不是project
          const pixel = this.map.projectToContainer(
            new this.TMapAPI.LatLng(coord.lat, coord.lng),
          );
          const intensity = (item.count || 1) / max;

          const gradient = ctx.createRadialGradient(
            pixel.x,
            pixel.y,
            0,
            pixel.x,
            pixel.y,
            currentRadius,
          );
          // 调整颜色渐变，让中心更集中，边缘更柔和
          gradient.addColorStop(0, `rgba(255, 0, 0, ${intensity * 1.0})`);
          gradient.addColorStop(0.3, `rgba(255, 100, 0, ${intensity * 0.8})`);
          gradient.addColorStop(0.6, `rgba(255, 200, 0, ${intensity * 0.5})`);
          gradient.addColorStop(1, "rgba(255, 255, 0, 0)");

          ctx.fillStyle = gradient;
          ctx.beginPath();
          ctx.arc(pixel.x, pixel.y, currentRadius, 0, Math.PI * 2);
          ctx.fill();
        });
      };

      // 使用节流优化地图移动和缩放时的热力图更新
      // 移动时使用更短的延迟，提高响应性
      this.map.on("move", () => {
        if (!this.isZooming && this.showMap) {
          // 移动时立即更新，不使用节流，让热力图跟随地图移动
          updateHeatmap();
        }
      });

      this.map.on("zoomstart", () => {
        this.isZooming = true;
      });

      this.map.on("zoom_changed", () => {
        // 立即标记缩放结束
        this.isZooming = false;

        // 使用较短的延迟更新热力图，提高响应性
        this.throttleUpdate(() => {
          if (this.showMap) {
            updateHeatmap();
          }
        }, 100);
      });
    },

    updateMarkers() {
      // 如果当前显示的是热力图，不更新标记点
      if (this.showMap) {
        return;
      }

      if (!this.map) {
        console.warn("地图未初始化，无法更新标记点");
        return;
      }
      // 移除缩放时的阻止，让标记点跟随地图流畅移动

      // 确保TMapAPI已初始化
      if (!this.ensureTMapAPI()) {
        console.warn("TMapAPI未初始化，无法更新标记点，等待重试...");
        setTimeout(() => {
          if (this.ensureTMapAPI()) {
            this.updateMarkers();
          }
        }, 200);
        return;
      }

      // 如果当前显示的是热力图，不创建标记点
      if (this.showMap) {
        return;
      }

      if (!this.markerList || this.markerList.length === 0) {
        console.log("标记点列表为空");
        return;
      }

      // 如果标记点已存在且数据相同，不需要重新创建
      if (this.multiMarker && this.multiMarker.getMap() === this.map) {
        // 标记点已存在且已显示，不需要重新创建
        return;
      }

      // 移除旧的标记点
      if (this.multiMarker) {
        try {
          this.multiMarker.setMap(null);
          this.multiMarker = null;
        } catch (e) {
          console.error("移除旧标记点失败:", e);
        }
      }

      console.log("开始创建标记点，数量:", this.markerList.length);

      // 创建标记点样式
      const markerStyles = {};
      const geometries = [];

      this.markerList.forEach((item, index) => {
        if (!item.lat || !item.lng) {
          console.warn("标记点数据缺少经纬度:", item);
          return;
        }

        try {
          // 坐标转换
          const coord = this.convertCoordinate(item.lat, item.lng);

          const styleId = `marker_${index}`;
          markerStyles[styleId] = new this.TMapAPI.MarkerStyle({
            width: item.size?.width || 20,
            height: item.size?.height || 25,
            anchor: {
              x: (item.size?.width || 20) / 2,
              y: item.size?.height || 25,
            },
            src: item.hotmarkImg || this.hotmarkImg,
          });

          geometries.push({
            id: `marker_${index}`,
            styleId: styleId,
            position: new this.TMapAPI.LatLng(coord.lat, coord.lng),
            properties: {
              data: item,
            },
          });
        } catch (e) {
          console.error("创建标记点样式失败:", e, item);
        }
      });

      if (geometries.length === 0) {
        console.warn("没有有效的标记点数据");
        return;
      }

      try {
        this.multiMarker = new this.TMapAPI.MultiMarker({
          map: this.map,
          styles: markerStyles,
          geometries: geometries,
        });

        // 绑定点击事件
        this.multiMarker.on("click", (evt) => {
          const data = evt.geometry?.properties?.data;
          if (data) {
            this.getwindowInfo(data);
          }
        });

        console.log("标记点创建成功，数量:", geometries.length);
      } catch (e) {
        console.error("创建标记点失败:", e);
      }
    },

    getHotInfo() {
      getHot({
        img: 1,
      })
        .then((res) => {
          console.log("获取热力图数据成功:", res.data);
          this.mapList = res.data || [];
          this.markerList = res.data ? [...res.data] : [];
          this.markerList.forEach((item) => {
            // 转换坐标并保存原始坐标
            if (item.lat && item.lng) {
              const coord = this.convertCoordinate(item.lat, item.lng);
              item.originalLat = item.lat; // 保存原始坐标
              item.originalLng = item.lng;
              item.lat = coord.lat; // 使用转换后的坐标
              item.lng = coord.lng;
            }
            item.hotmarkImg = require("@/assets/images/home/hotmark.png");
            item.size = {
              width: 20,
              height: 25,
            };
          });

          // 确保默认显示热力图，不显示点位图
          this.showMap = true;
          this.typeList[0].clicked = true;
          this.typeList[1].clicked = false;

          // 确保地图已初始化后再更新
          if (this.map && this.TMapAPI) {
            // 只显示热力图，不显示点位图
            this.updateHeatmap();
            // 确保标记点隐藏
            if (this.multiMarker) {
              this.multiMarker.setMap(null);
            }
          } else {
            console.warn("地图未初始化，等待初始化后再更新数据");
            // 如果地图还没初始化，等待一下
            setTimeout(() => {
              if (this.map && this.TMapAPI) {
                // 只显示热力图，不显示点位图
                this.updateHeatmap();
                // 确保标记点隐藏
                if (this.multiMarker) {
                  this.multiMarker.setMap(null);
                }
              }
            }, 500);
          }
        })
        .catch((error) => {
          console.error("获取热力图数据失败:", error);
        });
    },

    getwindowInfo(e) {
      const that = this;
      if (that.markerList.length == "1") {
        that.id = that.markerList[0].id;
        that.handleToOne(that.markerList[0]);
      } else {
        that.id = e.id;
        that.handleToOne(e);
      }
    },

    chooseType(item) {
      // 如果点击的是当前已选中的tab，不处理
      if (item.clicked) {
        return;
      }

      // 重置所有tab状态
      this.typeList.forEach((val) => {
        val.clicked = false;
      });

      // 设置当前选中的tab
      this.$set(item, "clicked", true);

      // 根据选择的类型更新显示
      if (item.value == "1") {
        // 热力图
        this.showMap = true;
      } else {
        // 点位图
        this.showMap = false;
      }

      // 更新地图显示
      this.updateMapData();
    },

    querySearch(queryString, cb) {
      getHot({
        img: 1,
        name: queryString,
      }).then((res) => {
        this.mapList = res.data;
        var results = this.mapList;
        cb(results);
      });
    },

    handleSelect(item) {
      // 搜索时切换到点位图
      this.showMap = false;
      this.typeList[0].clicked = false;
      this.typeList[1].clicked = true;
      this.keyword = item.name;
      this.id = item.id;
      this.showSearch = true;
      this.handleToOne();
      // 更新地图显示
      this.updateMapData();
    },

    handleIconClick() {
      this.keyword = "";
      this.markerList = JSON.parse(JSON.stringify(this.mapList));
      this.center = {
        lng: 120.330219,
        lat: 31.68196,
      };
      this.showSearch = false;
      this.info = {};
      this.markerList.forEach((item) => {
        item.hotmarkImg = require("@/assets/images/home/hotmark.png");
        item.size = {
          width: 20,
          height: 25,
        };
      });
      this.updateMapData();
    },

    handleToOne(tag) {
      getHotOne({
        id: this.id,
      }).then((res) => {
        this.info = res.data;

        if (!tag) {
          this.markerList = [];
          this.markerList.push(this.info);
          this.center = {
            lng: this.info.lng,
            lat: this.info.lat,
          };
          this.markerList[0].hotmarkImg = require("@/assets/images/position.gif");
          this.markerList[0].size = {
            width: 48,
            height: 80,
          };
        } else {
          this.markerList.forEach((item) => {
            if (item.id == this.id) {
              item.hotmarkImg = require("@/assets/images/position.gif");
              item.size = {
                width: 48,
                height: 80,
              };
            } else {
              item.hotmarkImg = require("@/assets/images/home/hotmark.png");
              item.size = {
                width: 20,
                height: 25,
              };
            }
          });
        }
        this.updateMarkers();
      });
    },

    handleToDetail(tag) {
      this.ImgUrl = tag;
      this.imgViewDlgVisible = true;
    },

    handleNative() {
      // 处理原生方法
    },
  },
};
</script>

<style lang="scss" scoped>
.autocompelete {
  position: absolute;
  top: 60px;
  padding: 20px 10px;
  z-index: 1000;

  &-right {
    right: 20px;
  }
}

.unchecked {
  font-size: 14px;
  color: #333333;
  background-color: #ffffff;
  width: 100px;
  height: 40px;
  line-height: 40px;
  box-shadow: 0px 1px 8px 0px rgba(151, 151, 151, 0.4);
}

.checkedStyle {
  font-size: 14px;
  color: #ffffff;
  background-color: #459bff;
  width: 100px;
  height: 40px;
  line-height: 40px;
  box-shadow: 0px 1px 8px 0px rgba(151, 151, 151, 0.4);
}

::v-deep .el-select {
  background-color: #ffffff;
}

::v-deep .el-input__inner {
  border: none;
}

.my-autocomplete {
  li {
    line-height: normal;
    padding: 7px;

    .name {
      text-overflow: ellipsis;
      overflow: hidden;
      font-size: 14px;
      font-weight: bold;
      color: #333333;
      line-height: 40px;
      margin-left: 15px;
    }

    .addr {
      font-size: 14px;
      color: #999999;
      line-height: 40px;
      margin-left: 15px;
    }

    .highlighted .addr {
      color: #ddd;
    }
  }
}

::v-deep .el-input__suffix {
  border-left: 1px solid;
  margin: 10px 0;
  height: -webkit-fill-available;
}

::v-deep .el-input__icon {
  line-height: 26px;
  margin: 0 20px;
}

::v-deep .el-input {
  width: 398px;
  background: #ffffff;
  box-shadow: 0px 1px 8px 0px rgba(151, 151, 151, 0.4);
  border-radius: 4px 0px 0px 4px;
}

.search_img {
  width: 18px;
  height: 20px;
}

.mt_9 {
  margin-top: 9px;
}

.searchInfo {
  width: 456px;
  padding: 20px 0;
  box-sizing: border-box;
  background: #f6f8fa;
  box-shadow: 0px 1px 13px 0px rgba(151, 151, 151, 0.4);
  border-radius: 3px;
  margin-left: 16px;
}

.local_img {
  width: 12px;
  height: 14px;
  margin-top: 3px;
}

::v-deep .el-divider--horizontal {
  margin: 20px 0;
}

.plr_20 {
  padding: 0 20px;
}

.left_icon {
  width: 4px;
  height: 14px;
  background: #459bff;
  border-radius: 2px;
  margin-top: 3px;
}

.bg_num {
  width: 128px;
  height: 85px;
  background: #edf0f3;
  border-radius: 2px;
  margin-left: 20px;
  position: relative;
  padding: 24px 0 0 24px;
}

.mt_15 {
  margin-top: 15px;
}

.num_img {
  width: 40px;
  height: 36px;
  position: absolute;
  bottom: 0;
  right: 0;
}

.info_img {
  width: 128px;
  height: 85px;
  margin-right: 15px;
}

.imageList {
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  width: 100%;
  display: inline;
  float: left;
  box-sizing: border-box;
}

/* 去除腾讯地图版权信息 */
::v-deep .tmap-copyright {
  display: none !important;
}

/* 隐藏腾讯地图缩放控件（+/-按钮） */
::v-deep .tmap-zoom,
::v-deep .tmap-control-zoom,
::v-deep [class*="zoom-control"],
::v-deep [class*="ZoomControl"],
::v-deep .tmap-ctrl-zoom,
::v-deep .tmap-ctrl-container {
  display: none !important;
}

/* 隐藏所有可能包含缩放控件的容器 */
::v-deep .tmap-ctrl {
  display: none !important;
}

/* 如果缩放控件在特定位置，也可以这样隐藏 */
::v-deep .tmap-ctrl-top-right,
::v-deep .tmap-ctrl-top-left {
  display: none !important;
}
</style>
